// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + {"532":"styles","678":"component---src-pages-index-js","682":"component---src-pages-about-js"}[chunkId] + "-" + {"532":"f21b7658991e7306d99c","678":"ff65452f1b4648a606fc","682":"99ebf603033e669ec2c6"}[chunkId] + ".js";
};